"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgCancellationOn = function SvgCancellationOn(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.451 2.56C5.636 2.295 7.877 2 12 2s6.364.295 7.549.56c1.033.23 1.612 1.105 1.712 2.034.133 1.233.314 3.329.314 5.619 0 .219-.002.434-.005.646-.057 3.85-2.011 7.44-5.31 9.46-.732.449-1.488.863-2.202 1.166-.702.299-1.42.515-2.058.515-.638 0-1.356-.216-2.058-.515-.714-.303-1.47-.717-2.201-1.165-3.3-2.02-5.254-5.612-5.31-9.46a44.172 44.172 0 0 1-.005-.647c0-2.29.18-4.386.313-5.619.1-.929.679-1.804 1.712-2.034Zm12.292 6.727c.228-.35.284-.805.036-1.142a3.344 3.344 0 0 0-1.027-.901c-.46-.266-1.01-.063-1.315.37a301.75 301.75 0 0 0-3.026 4.368s-.698-.869-1.86-2.117c-.402-.433-1.056-.52-1.502-.132a5.6 5.6 0 0 0-.736.768c-.297.382-.234.91.07 1.286a40.588 40.588 0 0 0 3.05 3.367 1.478 1.478 0 0 0 2.218-.122c.864-1.075 2.248-2.916 4.092-5.745Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgCancellationOn);
var _default = exports["default"] = Memo;